import { type Scene } from '@babylonjs/core/scene';
import { type Nullable } from '@babylonjs/core/types';

export class SeamRenderable {
  /** Piece ID. */
  public readonly id: string;
  /** Babylon scene. */
  public readonly scene: Scene;

  constructor(id: string, scene: Scene, parent?: Nullable<Node>) {
    this.id = id;
    this.scene = scene;
  }
}
